import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageTransactionMessagePreference } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  MessageTransactionMessagePreferenceEntityActionTypes,
  CreateMessageTransactionMessagePreferenceOnServer,
  CreateMessageTransactionMessagePreferenceOnServerSuccess,
  GetMessageTransactionMessagePreferencesFromServer,
  GetMessageTransactionMessagePreferencesFromServerSuccess,
  UpdateMessageTransactionMessagePreferenceOnServer,
  UpdateMessageTransactionMessagePreferenceOnServerSuccess,
  DeleteMessageTransactionMessagePreferenceFromServer,
  DeleteMessageTransactionMessagePreferenceFromServerSuccess
} from './message-transaction-message-preference.actions';

@Injectable()
export class MessageTransactionMessagePreferenceEntityEffects {
  
  getSelectedMessageTransactionMessagePreferencesFromServer = createEffect(() => this.dataPersistence.fetch(
    MessageTransactionMessagePreferenceEntityActionTypes.GetMessageTransactionMessagePreferencesFromServer,
    {
      run: (action: GetMessageTransactionMessagePreferencesFromServer, state: any) => {
        return this.apiService
          .get<MessageTransactionMessagePreference[]>(`v/1/fixed-operations/message-transaction-message-preferences/`, {
            params: action.payload.params
          })
          .pipe(
            map(messageTransactionMessagePreferences => {
              return new GetMessageTransactionMessagePreferencesFromServerSuccess(messageTransactionMessagePreferences);
            })
          );
      },
      onError: (action: GetMessageTransactionMessagePreferencesFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  
  updateMessageTransactionMessagePreferenceOnServer = createEffect(() => this.dataPersistence.fetch(
    MessageTransactionMessagePreferenceEntityActionTypes.UpdateMessageTransactionMessagePreferenceOnServer,
    {
      run: (action: UpdateMessageTransactionMessagePreferenceOnServer, state: any) => {
        return this.apiService
          .put<MessageTransactionMessagePreference[]>(
            `v/1/fixed-operations/message-transaction-message-preferences/${
              action.payload.messageTransactionMessagePreference.id
            }`,
            action.payload.messageTransactionMessagePreference,
            {
              params: action.payload.messageTransactionMessagePreferenceQueryParams
            }
          )
          .pipe(
            map(messageTransactionMessagePreference => {
              return new UpdateMessageTransactionMessagePreferenceOnServerSuccess(messageTransactionMessagePreference);
            })
          );
      },
      onError: (action: UpdateMessageTransactionMessagePreferenceOnServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  
  createMessageTransactionMessagePreferenceOnServer = createEffect(() => this.dataPersistence.fetch(
    MessageTransactionMessagePreferenceEntityActionTypes.CreateMessageTransactionMessagePreferenceOnServer,
    {
      run: (action: CreateMessageTransactionMessagePreferenceOnServer, state: any) => {
        return this.apiService
          .post<MessageTransactionMessagePreference[]>(
            `v/1/fixed-operations/message-transaction-message-preferences`,
            action.payload.messageTransactionMessagePreference
          )
          .pipe(
            map(messageTransactionMessagePreference => {
              return new CreateMessageTransactionMessagePreferenceOnServerSuccess(messageTransactionMessagePreference);
            })
          );
      },
      onError: (action: CreateMessageTransactionMessagePreferenceOnServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  
  deleteMessageTransactionMessagePreferenceFromServer = createEffect(() => this.dataPersistence.fetch(
    MessageTransactionMessagePreferenceEntityActionTypes.DeleteMessageTransactionMessagePreferenceFromServer,
    {
      run: (action: DeleteMessageTransactionMessagePreferenceFromServer, state: any) => {
        return this.apiService
          .delete<MessageTransactionMessagePreference[]>(
            `v/1/fixed-operations/message-transaction-message-preferences/${
              action.payload.messageTransactionMessagePreference.id
            }`,
            action.payload.messageTransactionMessagePreference
          )
          .pipe(
            map(messageTransactionMessagePreference => {
              return new DeleteMessageTransactionMessagePreferenceFromServerSuccess({
                messageTransactionMessagePreference: action.payload.messageTransactionMessagePreference
              });
            })
          );
      },
      onError: (action: DeleteMessageTransactionMessagePreferenceFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router
  ) {}
}
